module.exports = __webpack_public_path__ + "img/S-O_younique.png";